import { WidgetContainer } from '../../container/WidgetContainerInterface'
import { DragDropAction } from './DragDropAction'
import { DragDropContainerRequestFunc, DragDropEventCallbackFunction } from './DragDropTypes'

class DragDropTarget {
  protected targetElement: HTMLElement

  protected $onDragEnter: DragDropEventCallbackFunction
  protected $onDragOver: DragDropEventCallbackFunction
  protected $onDragLeave: DragDropEventCallbackFunction
  protected $onDrop: DragDropEventCallbackFunction

  protected $containerRequestFunc: DragDropContainerRequestFunc

  protected allowedWidgetTypes: string[] = []
  protected targetIsLateInitializer: boolean = false
  protected forceExactDrop: boolean = false

  constructor(targetElement: HTMLElement, forceExactDrop?: boolean) {
    this.targetElement = targetElement

    if (forceExactDrop !== undefined) {
      this.forceExactDrop = forceExactDrop
    }
  }

  protected notifyListener(action: DragDropAction, listener?: DragDropEventCallbackFunction) {
    if (typeof listener === 'undefined') {
      return
    }

    listener(action, false)
  }

  getTargetElement(): HTMLElement {
    return this.targetElement
  }

  getAllowedWidgetTypes(): string[] {
    return this.allowedWidgetTypes.length ? this.allowedWidgetTypes : ['*']
  }

  allow(widgetTypes: string): this {
    let allowedWidgetTypes = (widgetTypes || '*').split(',').map(widgetType => widgetType.trim())

    allowedWidgetTypes.forEach(widgetType => {
      if (this.allowedWidgetTypes.includes(widgetType)) {
        return
      }
      this.allowedWidgetTypes.push(widgetType)
    })

    return this
  }

  onRequestContainer(cb: DragDropContainerRequestFunc): this {
    this.$containerRequestFunc = cb
    return this
  }

  onDragEnter(cb: DragDropEventCallbackFunction): this {
    this.$onDragEnter = cb
    return this
  }

  onDragOver(cb: DragDropEventCallbackFunction): this {
    this.$onDragOver = cb
    return this
  }

  onDragLeave(cb: DragDropEventCallbackFunction): this {
    this.$onDragLeave = cb
    return this
  }

  onDrop(cb: DragDropEventCallbackFunction): this {
    this.$onDrop = cb
    return this
  }

  enter(action: DragDropAction) {
    this.notifyListener(action, this.$onDragEnter)
  }

  dragOver(action: DragDropAction) {
    this.notifyListener(action, this.$onDragOver)
  }

  leave(action: DragDropAction) {
    this.notifyListener(action, this.$onDragLeave)
  }

  drop(action: DragDropAction) {
    this.notifyListener(action, this.$onDrop)
  }

  isLateInitializer(val: boolean): this {
    this.targetIsLateInitializer = val
    return this
  }

  getIsLateInitializer(): boolean {
    return this.targetIsLateInitializer
  }

  getForceExactDrop(): boolean {
    return this.forceExactDrop
  }

  getContainer(): WidgetContainer | null {
    if (!this.$containerRequestFunc) {
      return null
    }
    return this.$containerRequestFunc()
  }
}

export { DragDropTarget }
